import { Card, CardContent } from "@/components/ui/card";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import moneyLottie from "@/assets/lottie/money.lottie?url";
import { PromoTimer } from "../PromoTimer";
import { HeaderTitle } from "../HeaderTitle";
import { useFirebaseFunction } from "@/hooks/useFirebaseFunction";
import type { SerializedFirebaseTimestamp } from "../PromoTimer";
import { hasTimePassed } from "@/helpers/hasTimePassed";
import { centsToPrettyDollars } from "@skillscratch/shared-util";
// import { useViewTransition } from "@/hooks/useViewTransition";
import { useEffect } from "react";
import { useCountdownToTimestamp } from "@/hooks/useCountdownToTimestamp";
import { Button } from '../ui/button';
import { useModal } from '@/hooks/useModal';
import arrowLottie from "@/assets/lottie/arrow.lottie?url";
import { GuidedPurchaseModal } from "../Modals/GuidedPurchaseModal";

type GetUserPrivateInfoRequest = {
  fields?: string[];
};

type GetUserPrivateInfoResponse = {
  userInfo: {
    purchaseMade?: boolean;
    specialPromoProgress?: number;
    specialPromoEndTimestamp?: SerializedFirebaseTimestamp;
  };
};


export function PromoCard() {
  // const { navigateNormal } = useViewTransition(); 

  // const handleNavigate = () => {
  //   navigateNormal("/wallet", {
  //     replace: false,
  //     viewTransition: true,
  //   });
  // }

  const { isModalOpen } = useModal();

  const [userData, , , refreshUserData] = useFirebaseFunction<
    GetUserPrivateInfoRequest,
    GetUserPrivateInfoResponse
  >(
    'getUserPrivateInfo',
    (fn) => fn({ fields: ["purchaseMade", "specialPromoProgress", "specialPromoEndTimestamp"] }),
    []
  );

    const [
      promotionEndTimestamp, isPromotionEndTimestampLoading
    ] = useFirebaseFunction<void, SerializedFirebaseTimestamp>("getPromotionEndTimestamp", (fn) =>
      fn()
    );

  // const handleClick = () => {
  //   console.log('click registered');
  //   const targetElement = document.getElementById('balancecard-card');

  //   // console.log(targetElement);
  
  //   // Scroll the element into view if it exists
  //   if (targetElement) {
  //     targetElement.scrollIntoView({ 
  //       behavior: 'smooth', 
  //       block: 'center',
  //     });
  //   }
  // }

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    refreshUserData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalOpen])

  // const memoizedPurchaseMade = useMemo(() => {
  //   return userData?.userInfo?.purchaseMade
  // }, [userData?.userInfo?.purchaseMade])

  // const memoizedPurchaseMade = useMemo(() => {
  //   return userData?.userInfo?.purchaseMade
  // }, [userData?.userInfo?.purchaseMade])

  return (
    <Card className="w-full max-w-md min-h-[160px] overflow-hidden border-0 bg-white card-wrapper h-full relative">
      <CardContent className="px-6 py-5 relative z-10 card-content">
        <div className="absolute right-0 top-0 h-full w-2/3 bg-blue-100 inner-radius" 
          style={{ 
            clipPath: "polygon(65% 0, 100% 0, 100% 100%, 82% 100%)",
            zIndex: 10, 
          }}>
            <DotLottieReact
              src={moneyLottie}
              dotLottieRefCallback={(ref) => {
                  ref?.addEventListener("load", () => {
                  ref?.setLayout({ fit: "cover", align: [0.5, 0.5] });
                  });
              }}
              renderConfig={{
                  autoResize: true,
              }}
              style={{
                  position: "absolute",
                  inset: "0",
                  // borderBottomRightRadius: "10vw",
                  // borderBottomLeftRadius: "10vw",
                  overflow: "hidden",
              }}
              speed={0.5}
              segment={[65, 130]}
              autoplay
              loop
          />
        </div>
        <div className="flex flex-col space-y-4 -translate-y-2">
          {/* <div className="flex items-center mb-1">
            <span className="text-xl text-slate font-normal mr-2">Your Promo</span>
            <Badge className="text-base text-white">FREE5</Badge>
          </div>    */}
          {
            userData?.userInfo?.purchaseMade || !userData || !promotionEndTimestamp || hasTimePassed(promotionEndTimestamp) ?
            <DefaultSubcomponent specialPromoProgress={userData?.userInfo?.specialPromoProgress} 
            specialPromoEndTimestamp={userData?.userInfo?.specialPromoEndTimestamp} /> :
            <ExpiringSubcomponent promotionEndTimestamp={promotionEndTimestamp} isPromotionEndTimestampLoading={isPromotionEndTimestampLoading} />
          }
        </div>
      </CardContent>
    </Card>
  );
};

export function ExpiringSubcomponent({ promotionEndTimestamp, isPromotionEndTimestampLoading }: 
  { promotionEndTimestamp: SerializedFirebaseTimestamp | undefined, isPromotionEndTimestampLoading: boolean }) {

    const { openModal } = useModal();

    return (
      <>
        <div>
          <h2 className="text-blue text-3xl font-extrabold mb-0">Free $5 credit</h2>
          <Button 
              className="py-6 bg-green text-white text-lg font-bold w-fit rounded-lg flex items-center justify-center gap-2 mt-2"
              shine
              onClick={() => {
                openModal(<GuidedPurchaseModal />);
              }}
            >
              <span className='items-center justify-center text-2xl w-fit'>Tap to use</span>
              <span className='flex items-center justify-center'>
                <DotLottieReact
                  src={arrowLottie}
                  autoplay
                  loop
                  style={{
                    height: "20px",
                    width: "20px",
                    objectFit: "contain",
                  }}
                />
              </span>
          </Button>
        </div>
        <p>
          <span className='text-lg'>
            Expires in
          </span> 
          <PromoTimer inline={true} promotionEndTimestamp={promotionEndTimestamp} isPromotionEndTimestampLoading={isPromotionEndTimestampLoading} />
        </p>
      </>
    );
}

export function DefaultSubcomponent({ specialPromoProgress, specialPromoEndTimestamp }: 
  { specialPromoProgress: number | undefined, specialPromoEndTimestamp: SerializedFirebaseTimestamp | undefined }) {

  // console.log('[specialPromoProgress]', specialPromoProgress);
  // console.log('[specialPromoProgress]');
  const progress = (specialPromoProgress ?? 0) / 5000;
  
  const { days, seconds } = useCountdownToTimestamp(specialPromoEndTimestamp);
  
  return (
    <>
      { specialPromoEndTimestamp && progress < 1 && seconds > 0? (
          <ProgressBar progress={progress} centsSpent={specialPromoProgress} days={days} />
        ) : (
          <>
            <h2 className="text-blue text-3xl font-extrabold">It's a great day <br />to scratch it big</h2>
            <HeaderTitle nameColor='text-blue text-xl' />
          </>
        )
      }
    </>
  );
}

export function ProgressBar({ progress = 0.5, centsSpent = 0, days = 0 }) {
  // Using the formula from your original code
  const progressWidth = `${7 + progress * 98}%`;

  if (centsSpent === undefined) {
    return null;
  }

  const progressString = progress >= 1 ? 'Complete' : centsToPrettyDollars(centsSpent, "full2");
  
  return (
    <>
      <div className="flex flex-col space-y-2">
        <h2 className="text-blue text-3xl font-extrabold">Scratch $50 of <br />cards, get $25</h2>
        <div className="flex items-center justify-between w-5/6">
          <div 
            className="relative overflow-hidden w-4/5 rounded-full"
            style={{
              height: "5vw",
              background: "#d9d9d9",
              borderRadius: "2.5vw",
            }}
          >
            <div
              className="h-full transition-width duration-100 flex items-center"
              style={{
                width: progressWidth,
                borderRadius: "2.5vw",
                background: '#35a0fd',
                willChange: "width",
              }}
            >
              <span className='ml-2 text-sm font-bold text-white'>{progressString}</span>
            </div>
          </div>
          <span className="ml-2 whitespace-nowrap ml-6 text-red-500 font-bold -translate-y-[1px]">{days} days left</span>
        </div>
      </div>
      <p className='text-blue opacity-60'>$25 paid out in promo cash</p>
    </>
  );
};